/// <amd-module name="Artifacts/Package/components/package-details-common/Metrics" />
import { MetricType } from "Artifacts/Root/types/MetricType";
import { PackageMetrics, PackageVersionMetrics } from "Artifacts/Root/web-apis/contracts/Feed";
import * as React from "react";
import * as Utils_String from "VSS/Core/Util/String";
import { Icon, IIconProps } from "VSSUI/Icon";
import { getFriendlyDisplayValue } from "VSSUI/Utilities/FriendlyNumber";

export interface IResourceStringPair {
  singular: string;
  plural: string;
}

export interface IMetricProps {
  metrics?: PackageMetrics | PackageVersionMetrics;
  metricType?: MetricType;
  className?: string;
  resourceStrings?: IResourceStringPair;
}

export class Metrics extends React.PureComponent<IMetricProps> {
  public render(): JSX.Element {
    const metricValue = this.getMetricValue(this.props.metrics, this.props.metricType);
    const displayString = this.getDisplayString(this.props.resourceStrings, metricValue);

    if (metricValue == null) {
      return <div></div>;
    }

    return (
      <div className={this.props.className}>
        {this.renderIcon(this.props.metricType)}
        <span>{displayString}</span>
      </div>
    );
  }

  getMetricValue(
    metrics?: PackageMetrics | PackageVersionMetrics,
    metricType?: MetricType,
  ): number | undefined {
    if (metrics == null) {
      return;
    }

    switch (metricType) {
      case MetricType.DownloadCount:
        return metrics.downloadCount || 0;
      case MetricType.UniqueUsers:
        return metrics.downloadUniqueUsers || 0;
      default:
        return 0;
    }
  }

  renderIcon(metricType?: MetricType): JSX.Element {
    let iconName: string;

    switch (metricType) {
      case MetricType.DownloadCount:
        iconName = "Download";
        break;
      case MetricType.UniqueUsers:
        iconName = "People";
        break;
      default:
        iconName = "";
    }
    if (iconName !== "") {
      const iconProps = { iconName } as IIconProps;
      return <Icon {...iconProps} className={"aggregated-metric-icon"} />;
    }
    return <Icon></Icon>;
  }

  getDisplayString(resourceStrings?: IResourceStringPair, metricValue?: number): string {
    if (metricValue == null) {
      return "";
    } else if (resourceStrings == null) {
      return getFriendlyDisplayValue(metricValue);
    } else if (metricValue === 1) {
      return Utils_String.format(resourceStrings.singular, getFriendlyDisplayValue(metricValue));
    } else {
      return Utils_String.format(resourceStrings.plural, getFriendlyDisplayValue(metricValue));
    }
  }
}
